import { render, staticRenderFns } from "./DatosBases.vue?vue&type=template&id=488ce8fe&scoped=true"
import script from "./DatosBases.vue?vue&type=script&lang=js"
export * from "./DatosBases.vue?vue&type=script&lang=js"
import style0 from "./DatosBases.vue?vue&type=style&index=0&id=488ce8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ce8fe",
  null
  
)

export default component.exports